/**
 * True when any audit that CREATE would make has no auditor picked.
 *
 * Works from what will be created — every `data` row with `selected` set, the
 * same rule as getAuditsToCreate (Store/audits-create/sagaUtils.js) — not from
 * auditsCreate.auditors alone. That list is only filled in once the Auditors
 * step renders, and CREATE sits in the sidebar on every step, so checking the
 * list by itself let an audit through whenever the list was empty (CREATE on
 * steps 1-3) or stale (Back + a changed selection). Those audits were then
 * assigned every auditor at the location, because data.userLocations defaults
 * to all of them.
 *
 * Ids are indexes into auditsCreate.data, so an entry only counts for an audit
 * if its branch and location still match (see reconcileAuditors.js).
 */
export default (data = [], auditors = []) =>
    data.some((item, index) => {
        if (!item.selected) return false;
        const id = item.id ?? index;
        return !auditors.some(
            (entry) =>
                entry.id === id &&
                entry.branch === item.branch &&
                entry.location === item.location &&
                Array.isArray(entry.selectedUsers) &&
                entry.selectedUsers.length > 0
        );
    });
